
import {
  Input,
  InputProps,
  styled,
} from '@mui/material'

export const StyledInput = styled((props: InputProps) => (
  <Input {...props} />
))(() => ({
  '&': {
    padding: '7px 8px',
    borderRadius: '8px',
    border: '1px solid #61667E',
    backgroundColor: '#2A3748',
    fontSize: '14px',
    lineHeight: '20px',
    transition: 'border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  '& .MuiInput-input': {
    padding: '0 0 0 8px',
  },
  '&:focus-within': {
    borderColor: '#388bfd',
    boxShadow: 'rgb(12, 45, 107) 0px 0px 0px 3px',
  },
}))
